import { PMP_EMAIL_DOMAIN } from "../constants/pMpConstants";
import { getUserDetails, ROLES } from "./isSystemControllerUser";

/**
 * True when the authenticated user may enter the /admin section — the
 * in-portal replacement for the Retool internal tools (EN-5129).
 *
 * Access requires BOTH the SuperAdmin role and a @patientmpower.com email:
 * the role alone is not enough, so a SuperAdmin assignment to an external
 * account never opens the internal tools.
 */
export function isSuperAdminUser(): boolean {
  const userDetails = getUserDetails();
  const email = userDetails?.userEmail ?? "";
  return (
    userDetails?.role === ROLES.SUPER_ADMIN &&
    email.toLowerCase().endsWith(PMP_EMAIL_DOMAIN)
  );
}
